import { useEffect, useRef } from "react"
import { Paper, StyleProp } from "@mantine/core"
import { SuspenseWithErrorBoundary } from "../../../../-components/suspense"
import { useDebouncedCallback } from "@mantine/hooks"
import { useGridStore } from "../../-components/DutyScheduling/state"

export function DutySchedulingContainer({
  children,
  mah,
  h,
}: {
  children: React.ReactNode
  mah?: StyleProp<React.CSSProperties["maxHeight"]> | undefined
  h?: StyleProp<React.CSSProperties["height"]> | undefined
}) {
  const setScrollPosition = useGridStore((s) => s.setScrollPosition)
  const gridRef = useRef<HTMLDivElement>(null)
  const updateScrollPositionDebounced = useDebouncedCallback(
    (data) => setScrollPosition(data),
    50
  )
  useEffect(() => {
    const node = gridRef.current
    if (!node) return
    function updatePos() {
      if (!node) return
      const scrollLeft = node.scrollLeft
      const scrollTop = node.scrollTop
      const pos = {
        left: scrollLeft,
        top: scrollTop,
        width: node.clientWidth,
        height: node.clientHeight,
      }
      updateScrollPositionDebounced(pos)
    }
    const handleScroll = () => {
      updatePos()
    }

    const resizeObserver = new ResizeObserver(() => {
      updatePos()
    })
    gridRef.current && resizeObserver.observe(gridRef.current)
    updatePos()
    node.addEventListener("scroll", handleScroll)
    return () => {
      resizeObserver.disconnect()
      node.removeEventListener("scroll", handleScroll)
    }
  }, [])
  return (
    <Paper
      ref={gridRef}
      withBorder
      mt="xs"
      p={0}
      mah={mah}
      h={h}
      style={{
        width: "100%",
        overflowX: "auto",
        overflowY: "auto",
        position: "relative",
        justifySelf: "start",
        alignSelf: "start",
      }}
    >
      <SuspenseWithErrorBoundary>{children}</SuspenseWithErrorBoundary>
    </Paper>
  )
}
